import React, {ReactNode} from 'react';

type BoxesWrapperProps = {
    boxes: ReactNode[],
    className?: string
}

function BoxesWrapper(props: BoxesWrapperProps) {
    const {boxes, className} = props
    return (
        <div className={`atoms-layouts-boxes${className ? " " + className : ""}`}>
            {
                boxes.map((box, index) => <div className={`box box-${index}`}>{box}</div>)
            }
        </div>
    );
}

export default BoxesWrapper;
